import { useCallback } from "react";
import { Breadcrumbs } from "~/components/UI";
import Users from "./Components/Users";
import { useTranslation } from "react-i18next";

/**
 * @namespace Users
 */

const UsersPage = () => {
  const { t } = useTranslation();

  const getBreadcrumbs = useCallback(() => {
    return [{ label: t("title.catalogs") }, { label: t("title.users") }];
  }, [t]);

  return (
    <>
      <Breadcrumbs links={getBreadcrumbs()} />
      <Users />
    </>
  );
};

export default UsersPage;
